import LegalSidebar from "../../components/legal/LegalSidebar";
import { Outlet } from "react-router-dom";

export default function LegalLayout() {
    return (
        <div className="flex">
            <LegalSidebar />
            <div className="flex-1 p-6 bg-white min-h-screen">
                <Outlet />
            </div>
        </div>
    );
}